module.exports = __webpack_public_path__ + "d11.no2.082e401f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d11.no2.jpg
// module id = mfgU
// module chunks = 0